module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Szczegóły widgetu",
      "before-close": _vm.handleClose,
      "width": "80vw",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "language-switcher"
  }, [_c('form-language-switcher')], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.formCopy,
      "label-width": "100px"
    }
  }, [(_vm.widgetType.global) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Widget"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz widget"
    },
    on: {
      "change": _vm.globalWidgetSet
    },
    model: {
      value: (_vm.formCopy.id),
      callback: function($$v) {
        _vm.$set(_vm.formCopy, "id", $$v)
      },
      expression: "formCopy.id"
    }
  }, _vm._l((_vm.availableWidgets), function(widget) {
    return _c('el-option', {
      key: widget.id,
      attrs: {
        "label": widget.name_pl,
        "value": widget.id
      }
    })
  }), 1)], 1)], 1) : _c('div', [_c('base-widget', {
    attrs: {
      "form": _vm.formCopy,
      "errors": _vm.errors
    },
    on: {
      "update:form": function($event) {
        _vm.formCopy = $event
      }
    }
  }), _vm._v(" "), _c(_vm.widgetComponent, {
    tag: "component",
    attrs: {
      "form": _vm.formCopy,
      "errors": _vm.errors
    },
    on: {
      "update:form": function($event) {
        _vm.formCopy = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancelForm()
      }
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("Zatwierdź\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-579da874"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/WidgetDialog.vue
// module id = 758
// module chunks = 0